import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import cardRejectedLabel from '@perpay-web/fintech/assets/images/CardRejectedLabel.svg';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ResponsiveHeader from '@perpay-web/fintech/components/base/ResponsiveHeader/ResponsiveHeader';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { useMount } from '@perpay-web/hooks/useMount';
import { useScrollReset } from '@perpay-web/hooks/useScrollReset';
import { formatCurrencyConditionalCents } from '@perpay-web/utils/stringUtils';

import styles from './NonCreditKarmaPartnerHostedOnboardingRejected.scss';

const NonCreditKarmaPartnerHostedOnboardingRejected = ({
    isLoading,
    spendingLimit,
    onClickDashboard,
    onMount,
}) => {
    useMount(onMount);

    useScrollReset();

    if (isLoading) return null;

    const formattedSpendingLimit =
        formatCurrencyConditionalCents(spendingLimit);

    return (
        <div className={styles.wrapper}>
            <LegacyFocusLayout
                className={styles.container}
                contentClassName={styles.content}
                footer={
                    <div className={styles.footer}>
                        <CardCta
                            Component={CustomLink}
                            href={`${paths.dashboard.path}?PHO_complete=true`}
                            onClick={onClickDashboard}
                            className={styles['footer-button']}
                        >
                            Unlock Offer
                        </CardCta>
                    </div>
                }
            >
                <div className={styles.heading}>
                    <ResponsiveHeader className={styles.header}>
                        Your card application was not approved
                    </ResponsiveHeader>
                    <ResponsiveCopy className={styles.copy}>
                        Please check your email for more information on this
                        decision. This decision will not impact your credit
                        score.
                    </ResponsiveCopy>
                    <ResponsiveCopy className={styles.copy}>
                        While your card application was not approved, based on
                        your information, we have another offer for you.
                    </ResponsiveCopy>
                </div>
                <div className={styles.card}>
                    <div className={styles.section__top}>
                        <div className={styles.pill}>New offer</div>
                        <div className={styles['spending-limit']}>
                            {formattedSpendingLimit}
                        </div>
                        <div className={styles.description}>
                            Pre-approved spending limit to shop the Perpay
                            Marketplace
                        </div>
                        <div className={styles.illustration} />
                        <img
                            src={cardRejectedLabel}
                            className={styles['illustration-label']}
                            alt='Label'
                        />
                    </div>
                    <Stack className={styles.section__bottom}>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon} />
                            Build credit across the 3 major credit bureaus:
                            Experian, Equifax and TransUnion.
                        </div>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon} />
                            Shop top brands and make interest-free installments
                            from your paycheck.
                        </div>
                        <div className={styles.list__item}>
                            <div className={styles.list__icon} />
                            Increase your chances of getting approved for the
                            Perpay Credit Card.
                        </div>
                    </Stack>
                </div>
            </LegacyFocusLayout>
        </div>
    );
};

export default NonCreditKarmaPartnerHostedOnboardingRejected;
